import { render, staticRenderFns } from "./GameBuilderCreate.vue?vue&type=template&id=3609824e&"
import script from "./GameBuilderCreate.vue?vue&type=script&lang=js&"
export * from "./GameBuilderCreate.vue?vue&type=script&lang=js&"
import style0 from "./GameBuilderCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports